import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { inject } from '@angular/core';
import { USER_ROLES } from '@shared/index';
import { EncryptionStorageService } from './services/encryption-storage.service';

export const superAdminGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const authGuardService: AuthService = inject(AuthService);
  const encryptStorage: EncryptionStorageService = inject(EncryptionStorageService);
  const roleName = encryptStorage.getItem('roleName')
  if (authGuardService.isLoggedIn() && roleName === USER_ROLES.SUPER_ADMIN) {
    return true;

  } router.navigate(['login'])
    return false
};
